// export const apiClientPath = "http://localhost:8080"
// export const apiClientPath = "https://spnvsachsen.de/api"
export const apiClientPath = "https://spnvsachsen.de/fahrausweisauswertung"
// export const startseite = "http://localhost:3000"
export const startseite = "https://spnvsachsen.de"

export const userAdmin = 'level2';
export const userVci = 'level1';
export const userZv = 'level0';
export const userMinisterium = 'level1';


export const sdMenu = "/stammdaten"

export const sdTabellenCollectionEbeneEins = [
    {
        header: 'Eisenbahninfrastrukturunternehmen',
        kurz: 'eiu'
    },
    {
        header: 'Eisenbahnverkehrsunternehmen',
        kurz: 'evu'
    },
    {
        header: 'Kreis',
        kurz: 'kreis'
    },
    {
        header: 'Linie',
        kurz: 'linie'
    },
    {
        header: 'Streckenkategorie',
        kurz: 'strkat'
    },
    {
        header: 'Zweckverband',
        kurz: 'verband'
    }
];

export const sdTabellenCollectionEbeneZwei = [
    {
        header: "Abschnitt",
        kurz: "abs"
    },
    {
        header: 'Bahnhof',
        kurz: 'bhf'
    },
    {
        header: "Infrastruktur",
        kurz: "infra"
    },
    {
        header: 'Verkehrsvertrag',
        kurz: 'vertrag'
    }
];

export const sdTabellenCollectionEbeneDrei = [
    {
        header: 'Linienführung',
        kurz: 'linienfuehrung'
    },
    {
        header: 'Vertrag zu Linie zu Produkt',
        kurz: 'vertraglinieprodukt'
    }
];

export const sdTabellenCollection = sdTabellenCollectionEbeneEins.concat(
    sdTabellenCollectionEbeneZwei,
    sdTabellenCollectionEbeneDrei
);

export const deTabellen = [
    {
        header: 'Abschnittsdaten',
        kurz: 'absdat'
    },
    {
        header: 'Bahnhofsdaten',
        kurz: 'bhfdat'
    },
    {
        header: 'Liniendaten',
        kurz: 'lindat'
    },
    {
        header: 'Verkehrsvertragsdaten',
        kurz: 'vvdat'
    },
];

export const MINCOL = '8.5em';
export const INPUTCOL = '10em';
export const KOMCOL = '20em';
export const DOUBLECOL = '22em';